import { createAction, props } from '@ngrx/store';

export const initNameCounters = createAction('[Name Counters Action] Init Counters', props<{ tools: any[] }>());
export const addNameToCounterCollection = createAction('[Name Counters Action] Add Name', props<{ alias: string }>());
export const clearNameCounters = createAction('[Name Counters Action] Clear Name Counters');
